import { render, staticRenderFns } from "./SBMailAuthentication.html?vue&type=template&id=6ecb42d4&scoped=true&"
import script from "./SBMailAuthentication.ts?vue&type=script&lang=ts&"
export * from "./SBMailAuthentication.ts?vue&type=script&lang=ts&"
import style0 from "./SBMailAuthentication.css?vue&type=style&index=0&id=6ecb42d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb42d4",
  null
  
)

export default component.exports